<template>
  <v-container fluid class="fill-height">
    <!-- dashboard sidebar -->
    <sidebar></sidebar>
    <!-- right content -->
    <v-row class="ml-5 fill-height">
      <v-col cols="12">
        <!-- supervisors on shift -->
        <base-title no-margin-top class=""> Supervisors on Shift </base-title>
        <div class="mt-2">
          <supervisor-item
            v-for="name in supervisors"
            :key="name"
            :name="name"
          ></supervisor-item>
        </div>

        <!-- doctors table -->
        <div>
          <base-title>Doctors</base-title>

          <!-- doctors -->
          <doctors-table
            v-model="doctors"
            @newcase="consolelog"
          ></doctors-table>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import API from "@/api";
const User = API.get("User");
export default {
  name: "Dashboard",

  components: {
    Sidebar: () => import("./components/Sidebar"),
    SupervisorItem: () => import("./components/SupervisorItem"),
    DoctorsTable: () => import("./components/DoctorsTable"),
  },

  data() {
    return {
      supervisors: ["Robert Downy Jr.", "Andres Bonifacio", "Elizabeth Bayon"],
      doctors: [
        // { doctor: 'Jane Wright', specialization: 'Specializations', status: 'online', availability:'10:00 - 12:00 NN', calls:[]},
        // { doctor: 'Testing', specialization: 'Specializations', status: 'in call', availability:'10:00 - 12:00 NN', calls:[]},
        // { doctor: 'Gerti cory', specialization: 'Cardiology', status: 'acw', availability:'10:00 - 12:00 NN', calls:[]},
        // { doctor: 'Helen Taussig', specialization: 'Internal', status: 'offline', availability:'10:00 - 12:00 NN', calls:[]},
        // { doctor: 'Elizabeth Kubler-Ross', specialization: 'OBGyn', status: 'on break', availability:'10:00 - 12:00 NN', calls:[]},
      ],
    };
  },

  async mounted() {
    var testResponse = await User.getDoctors(null, { search: "" });
    var response = await User.getDoctors(testResponse.data.total, {
      search: "",
    });
    this.doctors = response.data.data
      .filter((doctor) => doctor.doctor)
      .map((doctor) => {
        var doctor_info = doctor.doctor;
        var specialization = "N⁄A";
        if (typeof doctor_info.specialization == "object")
          if (doctor_info.specialization !== null)
            if (doctor_info.specialization.specialization !== null)
              specialization =
                doctor_info.specialization.specialization.specialization;
        return {
          doctor: this.getFullName(doctor),
          specialization: specialization,
          status: doctor_info.status !== null ? doctor_info.status : "Offline",
          availability: "10:00 - 12:00 NN",
          calls: [],
          full: doctor,
        };
      });

    console.log(this.doctors);
  },

  methods: {
    consolelog(item) {
      console.log(item);
    },
    getFullName(item) {
      var name = "";
      var user = item.doctor;
      if (user !== null) {
        if (Object.prototype.hasOwnProperty.call(user, "fullname")) {
          name = user.fullname;
        } else {
          if (user.first_name || user.last_name) {
            name = `${user.first_name} ${user.last_name}`;
          } else {
            name = user.email;
          }
        }
      }
      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
.selected {
  box-shadow: 0px 0px 10px #258bf5;
}
</style>
